import { render, staticRenderFns } from "./GraficoProdutividade.vue?vue&type=template&id=130031b4&scoped=true&lang=pug"
import script from "./GraficoProdutividade.vue?vue&type=script&lang=js"
export * from "./GraficoProdutividade.vue?vue&type=script&lang=js"
import style0 from "./GraficoProdutividade.vue?vue&type=style&index=0&id=130031b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130031b4",
  null
  
)

export default component.exports